import { AxiosResponse } from "axios";
import api, { removeToken, setToken } from "../axiosInstance";

class AuthService {
  singUp = async (
    username: string,
    password: string,
    remember: boolean
  ): Promise<AxiosResponse> => {
    const response = await api.post("login", {
      username,
      password,
      remember,
    });

    if (response.data.token) {
      setToken(response.data.token);
      localStorage.setItem("token", response.data.token);
    }

    return response;
  };

  forgotPassword = async (username: string): Promise<AxiosResponse> => {
    const response = await api.post("password/forgot", {
      username,
    });

    // if (response.data.token) {
    //   setToken(response.data.token);
    //   localStorage.setItem("token", response.data.token);
    // }

    return response;
  };

  resetPassword = async (
    password: string,
    repeat_password: string,
    token: string
  ): Promise<AxiosResponse> => {
    const response = await api.post("password/reset", {
      password,
      repeat_password,
      token,
    });

    // if (response.data.token) {
    //   setToken(response.data.token);
    //   localStorage.setItem("token", response.data.token);
    // }

    return response;
  };

  checkResetToken = async (token: string): Promise<AxiosResponse> => {
    const response = await api.post("password/check_token", {
      token,
    });

    return response;
  };

  checkInviteToken = async (token: string): Promise<AxiosResponse> => {
    const response = await api.post("invite/check_token", {
      token,
    });

    return response;
  };

  setInvitePassword = async (
    password: string,
    repeat_password: string,
    token: string
  ): Promise<AxiosResponse> => {
    const response = await api.post("invite/password", {
      password,
      repeat_password,
      token,
    });

    // if (response.data.token) {
    //   setToken(response.data.token);
    //   localStorage.setItem("token", response.data.token);
    // }

    return response;
  };

  declineInvite = async (token: string): Promise<AxiosResponse> => {
    const response = await api.post("invite/decline", {
      token,
    });

    // if (response.data.token) {
    //   setToken(response.data.token);
    //   localStorage.setItem("token", response.data.token);
    // }

    return response;
  };

  acceptInvite = async (token: string): Promise<AxiosResponse> => {
    const response = await api.post("invite/accept", {
      token,
    });

    // if (response.data.token) {
    //   setToken(response.data.token);
    //   localStorage.setItem("token", response.data.token);
    // }

    return response;
  };

  logout = (): void => {
    removeToken();
    localStorage.removeItem("token");
    localStorage.removeItem("company_uuid");
  };

  getLoggedUser = async (): Promise<AxiosResponse> => {
    const response = await api.get("users/me");
    return response;
  };
}

export default new AuthService();
